import express from 'express';
import { parsePayload } from '~/app/middleware';
import { deleteContentAssets } from '~/app/middleware/Assets';
import { deleteEntries } from '~/app/middleware/Entries';
import { deleteNodes } from '~/app/middleware/Nodes';
import { deleteContentTypes } from '../middleware/ContentTypes';
import { deleteTagGroups, deleteTags } from '../middleware/Tags';

const deleteRouter = express.Router();

deleteRouter.post(
  ['/contenttypes{/:preview}', '/components{/:preview}'],
  parsePayload,
  deleteContentTypes
);

deleteRouter.post('/assets{/:preview}', parsePayload, deleteContentAssets);
deleteRouter.post('/entries{/:preview}', parsePayload, deleteEntries());
deleteRouter.post('/nodes{/:preview}', parsePayload, deleteNodes);
deleteRouter.post('/taggroups{/:preview}', parsePayload, deleteTagGroups);
deleteRouter.post('/tags{/:preview}', parsePayload, deleteTags);

export default deleteRouter;
